var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"image-element",class:_vm.classes,style:(_vm.style)},[_c('div',{staticClass:"wrap",class:_vm.imageCounter},_vm._l((_vm.slides),function(slide,i){return _c('Images',{key:slide.id,attrs:{"slide":slide}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }